const getDepreciationInGeneralTotalTable = (grossPrice, netPrice) => {
    if (grossPrice <= 0 && netPrice <= 0) return null;
    const depreciation = 100 - ((netPrice * 100) / grossPrice);
    if (depreciation === 0) return null;
    return depreciation;
};

export default getDepreciationInGeneralTotalTable;
